/*! Deferred slideshow slide images — keeps non-first slides off the network until needed. */
function hydrateCarouselSlide(slide) {
  if (!slide || slide.dataset.lazyHydrated === "true") return;
  const placeholder = slide.querySelector("[data-lazy-mobile]");
  if (!placeholder) return;

  const mobile = placeholder.dataset.lazyMobile;
  const desktop = placeholder.dataset.lazyDesktop || mobile;
  const alt = placeholder.dataset.lazyAlt || "";
  const width = placeholder.dataset.lazyWidth || "750";
  const height = placeholder.dataset.lazyHeight || "";
  const pos = placeholder.dataset.lazyPosition || "";
  const posMobile = placeholder.dataset.lazyPositionMobile || pos;

  const img = document.createElement("img");
  img.className = placeholder.className.replace(" home-carousel--image_img--pending", "");
  img.src = mobile;
  img.srcset = `${mobile} ${width}w, ${desktop} 1200w`;
  img.fetchPriority = "low";
  img.sizes = "100vw";
  img.alt = alt;
  img.loading = "eager";
  img.decoding = "async";
  img.width = width;
  if (height) img.height = height;
  img.style.setProperty("--image-position", pos);
  img.style.setProperty("--image-position-mobile", posMobile);

  placeholder.replaceWith(img);
  slide.dataset.lazyHydrated = "true";
}

function hydrateUpcoming(carousel, index) {
  if (!carousel) return;
  const slides = carousel.querySelectorAll("media-carousel-slide");
  [index, index + 1].forEach((i) => {
    const slide = slides[i];
    if (slide) hydrateCarouselSlide(slide);
  });
}

function bindDeferredSlides(carousel) {
  if (!carousel || carousel.dataset.deferredSlidesBound === "true") return;
  carousel.dataset.deferredSlidesBound = "true";

  carousel.addEventListener("on:media-carousel:init", (e) => {
    hydrateUpcoming(carousel, e.detail?.activeIndex ?? 0);
  });
  carousel.addEventListener("on:media-carousel:before-slide-change", (e) => {
    hydrateUpcoming(carousel, e.detail?.activeIndex ?? 0);
  });
}

document.querySelectorAll("media-carousel.home-carousel--image[data-defer-slide-images]").forEach(bindDeferredSlides);
